import React, { lazy, Suspense, useEffect, useState } from "react";
import { Switch, Route, useLocation } from "react-router-dom";
import { SIGNIN_TOKEN, USER_REGISTRATION_PATHS } from "./constants";
import { SimplePersistence } from "./utils";
import style from "./styles/common.module.scss";
import { RenderSession } from "./renderSession";
import { CustomRoute } from "./routes/CustomRoutes";
import { useSelector } from "react-redux";
import { Loader } from "./components";

const Home = lazy(() => import("./containers/home").then((module) => ({ default: module.Home })));
const ResetPassword = lazy(() => import("./containers/resetPassword").then((module) => ({ default: module.ResetPassword })));
const LearnMore = lazy(() => import("./containers/learnMore").then((module) => ({ default: module.LearnMore })));
const UnAuthorizedContent = lazy(() => import("./containers/unAuthorizedContent").then((module) => ({ default: module.UnAuthorizedContent })));

const PatientsRoutes = lazy(() => import(/* webpackChunkName: "patients-route" */ "./routes/PatientsRoutes"));
const AuthRoutes = lazy(() => import(/* webpackChunkName: "auth-route" */ "./routes/AuthRoutes"));
const AdminRoutes = lazy(() => import(/* webpackChunkName: "admin-route" */ "./routes/AdminRoutes"));
const WoundReportRoutes = lazy(() => import(/* webpackChunkName: "wound-report-route" */ "./routes/WoundReportRoutes"));
const BiReportRoutes = lazy(() => import(/* webpackChunkName: "bi-report-route" */ "./routes/BiReportRoutes"));
const TreatmentReportRoutes = lazy(() => import(/* webpackChunkName: "treatment-report-route" */ "./routes/TreatmentReportRoutes"));
const QualityReportRoutes = lazy(() => import(/* webpackChunkName: "quality-report-route" */ "./routes/QualityReportRoutes"));
const PlatformAnalyticsRoutes = lazy(() => import(/* webpackChunkName: "platform-analytics-route" */ "./routes/PlatformAnalyticsRoutes"));
const WorklistRoutes = lazy(() => import(/* webpackChunkName: "worklist-route" */ "./routes/WorklistRoutes"));
const UserProfileRoutes = lazy(() => import(/* webpackChunkName: "user-profile-route" */ "./routes/UserProfileRoutes"));
const StatusRoutes = lazy(() => import(/* webpackChunkName: "status-route" */ "./routes/StatusRoutes"));

const storage = new SimplePersistence();
const isSignedIn = (user) => user && user.isSignedIn && !!storage.getItem(SIGNIN_TOKEN);

const RenderRoutes = ({ nav }) => {
  const location = useLocation();
  const user = useSelector((state) => state.user);
  const [resetSession, setResetSession] = useState(false);

  const showNav = isSignedIn(user) && !USER_REGISTRATION_PATHS.includes(location.pathname);
  useEffect(() => {
    if (showNav && user?.userDetails?.email && !resetSession) {
      setResetSession(true);
    }
  }, [showNav, user, resetSession]);
  return (
    <Suspense fallback={<Loader />}>
      <div className={`container-fluid ${style.medline_block}`}>
        <div className="row p-0">
          {showNav && (
            <>
              {resetSession && <RenderSession />}

              <div id={"check_left_block"} className={`${style.left_block}`} style={{ transition: "all 0.1s ease-in-out" }}>
                {nav()}
              </div>
            </>
          )}
          <div className={`${style.right_block}`} id={"check_right_block"}>
            <Switch>
              <Route path={USER_REGISTRATION_PATHS} render={() => <AuthRoutes />} />
              <Route exact path="/createpassword" component={ResetPassword} />
              <CustomRoute exact path="/" component={Home} />

              {/* <Route exact path="/extpdfviewer" component={ExternalPdfViewPage} /> */}
              <Route path="/worklist" render={(props) => <WorklistRoutes {...props} />} />
              <Route path="/userprofile" render={(props) => <UserProfileRoutes {...props} />} />
              <Route path="/status" render={(props) => <StatusRoutes {...props} />} />
              <Route path="/patients" render={(props) => <PatientsRoutes {...props} />} />
              <Route path="/admin" render={(props) => <AdminRoutes {...props} />} />
              <Route path="/woundReport" render={(props) => <WoundReportRoutes {...props} />} />
              <Route path="/biReports" render={(props) => <BiReportRoutes {...props} />} />
              <Route path="/treatmentReport" render={(props) => <TreatmentReportRoutes {...props} />} />
              <Route path="/qualityReport" render={(props) => <QualityReportRoutes {...props} />} />
              <Route path="/platformanalytics" render={(props) => <PlatformAnalyticsRoutes {...props} />} />

              <CustomRoute exact path="/learnMore" component={LearnMore} />
              <CustomRoute exact path="/unAuthorized" component={UnAuthorizedContent} />
              <Route component={UnAuthorizedContent} />
            </Switch>
          </div>
        </div>
      </div>
    </Suspense>
  );
};

export default RenderRoutes;
